import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Popup } from 'components';

import ServiceForm from './components/ServiceForm';
import ServiceDisconnectForm from './components/ServiceDisconnectForm';

const ServicePopup = ({
  onClose,
  content,
  connectionContent,
  service,
  accumulators,
  onSetPending,
}) => {
  const onSuccess = () => {
    onClose();
  };

  const isShowDisconnectForm = service.connected;

  return (
    <Popup opened onClose={onClose}>
      {isShowDisconnectForm ? (
        <ServiceDisconnectForm
          service={service}
          content={content.disconnectForm}
          onSetPending={(soc = null) => {
            onSetPending(soc);
          }}
          onSuccess={onSuccess}
          onErrorBtnClick={onClose}
        />
      ) : (
        <ServiceForm
          onSuccess={onSuccess}
          onSetPending={(soc = null) => {
            onSetPending(soc);
          }}
          onClose={onClose}
          connectionContent={connectionContent}
          content={content.connectForm}
          service={service}
          accumulators={accumulators}
        />
      )}
    </Popup>
  );
};

ServicePopup.propTypes = {
  content: PropTypes.object,
  connectionContent: PropTypes.object,
  service: PropTypes.object,
  accumulators: PropTypes.object,
  onClose: PropTypes.func,
  onSetPending: PropTypes.func,
};

const mapStateToProps = (state) => ({
  accumulators: state.home.accumulators.data,
  services: state.home.tariffServices.data.services,
});

export default connect(mapStateToProps)(ServicePopup);
